import '../../css/base.css';
import WalkBrae from './walkBrae';
import WalkDryIsland from './walkDryIsland';
import WalkCorran from './walkCorran';

const LocalWalks = () => {

  return (
    <div className="row" style={{"marginBottom": "1rem"}}>
      <div className="col-12 col-md-6">
        <WalkBrae />
      </div>
      <div className="col-12 col-md-6">
        <WalkDryIsland />
      </div>
      <div className="col-12 col-md-6">
        <WalkCorran />
      </div>
    </div>
  );
}

export default LocalWalks;